<template>
  <v-dialog
    v-model="value"
    fullscreen
    transition="dialog-bottom-transition"
  >
  <v-card>
    <v-toolbar
      dark
    >
      <v-btn
        icon
        color="primary"
        @click="close"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ strings.leaks }}</v-toolbar-title>
      <v-spacer />
      <v-btn
        icon
        color="primary"
        @click="save"
      >
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container
      v-for="(leak, index) in techData.leaks" :key="index"
      class="repair-leak v-card v-sheet space"
    >
      <v-layout
        align-space-between
        justify-space-around
        column
        fill-height
      >
        <v-flex 
          class="mt-3"
          align-space-between
          justify-space-around
          row
          fill-height
        >
          <prime-google-map
            :map-center="getCenter(leak)"
            :markers="getMarker(leak)"
          />
        </v-flex>
        <v-flex
          align-space-between
          justify-space-around
          row
          fill-height class="mt-3"
        >
          <v-text-field
            v-model="leak.workOrder"
            :label="strings.workOrder"
          />
        </v-flex>
        <v-flex
          align-space-between
          justify-space-around
          row
          fill-height
        >
          <v-text-field
            v-model="leak.actualRepairDate"
            type="date"
            :label="strings.repairDate"
          />
        </v-flex>
        <v-flex
          align-space-between
          justify-space-around
          row
          fill-height
        >
          <v-select
            v-model="leak.actualLeakType"
            :items="leakTypes"
            item-text="displayName"
            item-value="key"
            :label="strings.leakType"
            accent
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { TechnicianData } from "@primayer/poi-classes";
import { GenericMarkerData, LatLong } from "@primayer/prime-google-map";
import { LeakTypes } from "../config/leak.js";
import { CreateLogEntryObj, toDateString } from "../helpers/Utils.js";

export default {
  props: {
    value: {
      type: Boolean,
      default: () => false
    },
    poi: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      techData: {
        leaks: []
      },
      saving: false,
      loaded: false
    }
  },
  computed: {
    ...mapGetters("page", ["strings"]),
    leakTypes() {
      return LeakTypes.sort(this.namedSort);
    },
  },
  watch: {
    value(val) {
      if(val) {
        this.setup();
      }
    }
  },
  mounted() {
    this.setup();
  }, 
  methods: {
    setup() {
      this.techData = new TechnicianData(this.poi.technicianData);
      console.log(this.techData);
      this.loaded = true;
    },
    getCenter(leak) {
      return new LatLong([leak.leakCoords.latitude, leak.leakCoords.longitude]);
    },
    getMarker(leak) {
      let markerSetup = {
        latitude: leak.leakCoords.latitude,
        longitude: leak.leakCoords.longitude,
        clickable: false,
        draggable: false,
        zIndex: 9
      };
      return [new GenericMarkerData(markerSetup)];
    },
    close() {
      this.$emit("close", true);
    },
    save() {
      if(!this.saving) {
        this.saving = true;
        this.techData.leaks.forEach(leak => {
          if(leak.repairDate == null) {
            leak.repairDate = leak.actualRepairDate;
          }
        });
        var newLog = CreateLogEntryObj(
          this.poi.id,
          `Update Repair info`
        );

        this.techData.logEntry = newLog;
        this.techData.poiId = this.poi.id;
        this.techData.group = this.poi.customerGroupId;
        console.log(this.techData);
        this.$store.dispatch("group/saveRepair", this.techData)
        .then(res => {
          if(res) {
            this.$emit("close", true);
          }
          this.saving = false;
        })
      }
    },
    namedSort(a, b) {
      let nameA = a.name.toUpperCase(); // ignore upper and lowercase
      let nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;
    }
  }
}
</script>

<style lang="less" scoped>
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #666; 
  border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
  background: #666; 
}

.container.fluid.fill-height.repair-leak {
  background-color: #00000020;
  padding: 0rem 0rem 0.75rem 0.75rem;
}
.repair-leak.space {
  margin-top: 0.5rem;
}

.map-container {
  height: 10vh;
  width: 100%;
}
</style>